module.exports = "/images/profile_icon.svg?ada3531e4b35d1aab77564624ff074d4";